import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";

/**
 * Native select of onboarded fleet numbers from `/onboarding/vehicleList`.
 * If `value` is not in the list, adds an extra option so legacy or out-of-sync values still work.
 */
export default function FleetVehicleSelect({
  name = "vehicleNumber",
  value,
  onChange,
  style,
  required,
  disabled,
  id,
  className,
  placeholderOption = "Select vehicle",
}) {
  const [fleetNumbers, setFleetNumbers] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/onboarding/vehicleList`, { withCredentials: true })
      .then((res) => {
        const rows = Array.isArray(res.data) ? res.data : [];
        const ids = [...new Set(
          rows
            .map((v) => (typeof v === "string" ? v : v?.vehicleNumber))
            .map((x) => String(x || "").trim())
            .filter(Boolean)
        )];
        ids.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
        setFleetNumbers(ids);
      })
      .catch(() => setFleetNumbers([]));
  }, []);

  const v = String(value ?? "").trim();
  const inFleet = v && fleetNumbers.includes(v);

  return (
    <select
      id={id}
      className={className}
      name={name}
      style={style}
      value={value ?? ""}
      onChange={onChange}
      required={required}
      disabled={disabled}
    >
      <option value="">{placeholderOption}</option>
      {fleetNumbers.map((num) => (
        <option key={num} value={num}>{num}</option>
      ))}
      {v && !inFleet ? (
        <option value={v}>{v} — saved value (not in fleet list)</option>
      ) : null}
    </select>
  );
}
